export default "__VITE_PUBLIC_ASSET__aef9f17c__"